/**
 * @fileoverview gRPC-Web generated client stub for acompanha.printer_models.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v4.25.2
// source: acompanha/printer_models/v1/printer_models.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var acompanha_common_v1_common_pb = require('../../../acompanha/common/v1/common_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.acompanha = {};
proto.acompanha.printer_models = {};
proto.acompanha.printer_models.v1 = require('./printer_models_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.printer_models.v1.PrinterModelsServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.printer_models.v1.PrinterModelsServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.printer_models.v1.ListPrinterModelsRequest,
 *   !proto.acompanha.printer_models.v1.ListPrinterModelsResponse>}
 */
const methodDescriptor_PrinterModelsService_ListPrinterModels = new grpc.web.MethodDescriptor(
  '/acompanha.printer_models.v1.PrinterModelsService/ListPrinterModels',
  grpc.web.MethodType.UNARY,
  proto.acompanha.printer_models.v1.ListPrinterModelsRequest,
  proto.acompanha.printer_models.v1.ListPrinterModelsResponse,
  /**
   * @param {!proto.acompanha.printer_models.v1.ListPrinterModelsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.printer_models.v1.ListPrinterModelsResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.printer_models.v1.ListPrinterModelsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.printer_models.v1.ListPrinterModelsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.printer_models.v1.ListPrinterModelsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.printer_models.v1.PrinterModelsServiceClient.prototype.listPrinterModels =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.printer_models.v1.PrinterModelsService/ListPrinterModels',
      request,
      metadata || {},
      methodDescriptor_PrinterModelsService_ListPrinterModels,
      callback);
};


/**
 * @param {!proto.acompanha.printer_models.v1.ListPrinterModelsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.printer_models.v1.ListPrinterModelsResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.printer_models.v1.PrinterModelsServicePromiseClient.prototype.listPrinterModels =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.printer_models.v1.PrinterModelsService/ListPrinterModels',
      request,
      metadata || {},
      methodDescriptor_PrinterModelsService_ListPrinterModels);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.printer_models.v1.GetPrinterModelRequest,
 *   !proto.acompanha.printer_models.v1.GetPrinterModelResponse>}
 */
const methodDescriptor_PrinterModelsService_GetPrinterModel = new grpc.web.MethodDescriptor(
  '/acompanha.printer_models.v1.PrinterModelsService/GetPrinterModel',
  grpc.web.MethodType.UNARY,
  proto.acompanha.printer_models.v1.GetPrinterModelRequest,
  proto.acompanha.printer_models.v1.GetPrinterModelResponse,
  /**
   * @param {!proto.acompanha.printer_models.v1.GetPrinterModelRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.printer_models.v1.GetPrinterModelResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.printer_models.v1.GetPrinterModelRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.printer_models.v1.GetPrinterModelResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.printer_models.v1.GetPrinterModelResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.printer_models.v1.PrinterModelsServiceClient.prototype.getPrinterModel =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.printer_models.v1.PrinterModelsService/GetPrinterModel',
      request,
      metadata || {},
      methodDescriptor_PrinterModelsService_GetPrinterModel,
      callback);
};


/**
 * @param {!proto.acompanha.printer_models.v1.GetPrinterModelRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.printer_models.v1.GetPrinterModelResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.printer_models.v1.PrinterModelsServicePromiseClient.prototype.getPrinterModel =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.printer_models.v1.PrinterModelsService/GetPrinterModel',
      request,
      metadata || {},
      methodDescriptor_PrinterModelsService_GetPrinterModel);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.printer_models.v1.CreatePrinterModelRequest,
 *   !proto.acompanha.printer_models.v1.CreatePrinterModelResponse>}
 */
const methodDescriptor_PrinterModelsService_CreatePrinterModel = new grpc.web.MethodDescriptor(
  '/acompanha.printer_models.v1.PrinterModelsService/CreatePrinterModel',
  grpc.web.MethodType.UNARY,
  proto.acompanha.printer_models.v1.CreatePrinterModelRequest,
  proto.acompanha.printer_models.v1.CreatePrinterModelResponse,
  /**
   * @param {!proto.acompanha.printer_models.v1.CreatePrinterModelRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.printer_models.v1.CreatePrinterModelResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.printer_models.v1.CreatePrinterModelRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.printer_models.v1.CreatePrinterModelResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.printer_models.v1.CreatePrinterModelResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.printer_models.v1.PrinterModelsServiceClient.prototype.createPrinterModel =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.printer_models.v1.PrinterModelsService/CreatePrinterModel',
      request,
      metadata || {},
      methodDescriptor_PrinterModelsService_CreatePrinterModel,
      callback);
};


/**
 * @param {!proto.acompanha.printer_models.v1.CreatePrinterModelRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.printer_models.v1.CreatePrinterModelResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.printer_models.v1.PrinterModelsServicePromiseClient.prototype.createPrinterModel =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.printer_models.v1.PrinterModelsService/CreatePrinterModel',
      request,
      metadata || {},
      methodDescriptor_PrinterModelsService_CreatePrinterModel);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.printer_models.v1.UpdatePrinterModelRequest,
 *   !proto.acompanha.printer_models.v1.UpdatePrinterModelResponse>}
 */
const methodDescriptor_PrinterModelsService_UpdatePrinterModel = new grpc.web.MethodDescriptor(
  '/acompanha.printer_models.v1.PrinterModelsService/UpdatePrinterModel',
  grpc.web.MethodType.UNARY,
  proto.acompanha.printer_models.v1.UpdatePrinterModelRequest,
  proto.acompanha.printer_models.v1.UpdatePrinterModelResponse,
  /**
   * @param {!proto.acompanha.printer_models.v1.UpdatePrinterModelRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.printer_models.v1.UpdatePrinterModelResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.printer_models.v1.UpdatePrinterModelRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.printer_models.v1.UpdatePrinterModelResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.printer_models.v1.UpdatePrinterModelResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.printer_models.v1.PrinterModelsServiceClient.prototype.updatePrinterModel =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.printer_models.v1.PrinterModelsService/UpdatePrinterModel',
      request,
      metadata || {},
      methodDescriptor_PrinterModelsService_UpdatePrinterModel,
      callback);
};


/**
 * @param {!proto.acompanha.printer_models.v1.UpdatePrinterModelRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.printer_models.v1.UpdatePrinterModelResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.printer_models.v1.PrinterModelsServicePromiseClient.prototype.updatePrinterModel =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.printer_models.v1.PrinterModelsService/UpdatePrinterModel',
      request,
      metadata || {},
      methodDescriptor_PrinterModelsService_UpdatePrinterModel);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.printer_models.v1.DeletePrinterModelRequest,
 *   !proto.acompanha.common.v1.DeleteResponse>}
 */
const methodDescriptor_PrinterModelsService_DeletePrinterModel = new grpc.web.MethodDescriptor(
  '/acompanha.printer_models.v1.PrinterModelsService/DeletePrinterModel',
  grpc.web.MethodType.UNARY,
  proto.acompanha.printer_models.v1.DeletePrinterModelRequest,
  acompanha_common_v1_common_pb.DeleteResponse,
  /**
   * @param {!proto.acompanha.printer_models.v1.DeletePrinterModelRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  acompanha_common_v1_common_pb.DeleteResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.printer_models.v1.DeletePrinterModelRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.common.v1.DeleteResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.common.v1.DeleteResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.printer_models.v1.PrinterModelsServiceClient.prototype.deletePrinterModel =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.printer_models.v1.PrinterModelsService/DeletePrinterModel',
      request,
      metadata || {},
      methodDescriptor_PrinterModelsService_DeletePrinterModel,
      callback);
};


/**
 * @param {!proto.acompanha.printer_models.v1.DeletePrinterModelRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.common.v1.DeleteResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.printer_models.v1.PrinterModelsServicePromiseClient.prototype.deletePrinterModel =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.printer_models.v1.PrinterModelsService/DeletePrinterModel',
      request,
      metadata || {},
      methodDescriptor_PrinterModelsService_DeletePrinterModel);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesRequest,
 *   !proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesResponse>}
 */
const methodDescriptor_PrinterModelsService_ListMaintenanceTaskTypes = new grpc.web.MethodDescriptor(
  '/acompanha.printer_models.v1.PrinterModelsService/ListMaintenanceTaskTypes',
  grpc.web.MethodType.UNARY,
  proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesRequest,
  proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesResponse,
  /**
   * @param {!proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.printer_models.v1.PrinterModelsServiceClient.prototype.listMaintenanceTaskTypes =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.printer_models.v1.PrinterModelsService/ListMaintenanceTaskTypes',
      request,
      metadata || {},
      methodDescriptor_PrinterModelsService_ListMaintenanceTaskTypes,
      callback);
};


/**
 * @param {!proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.printer_models.v1.PrinterModelsServicePromiseClient.prototype.listMaintenanceTaskTypes =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.printer_models.v1.PrinterModelsService/ListMaintenanceTaskTypes',
      request,
      metadata || {},
      methodDescriptor_PrinterModelsService_ListMaintenanceTaskTypes);
};


module.exports = proto.acompanha.printer_models.v1;

